import { render, staticRenderFns } from "./DisplayActivityTable.vue?vue&type=template&id=a90a01c8&scoped=true&"
import script from "./DisplayActivityTable.vue?vue&type=script&lang=ts&"
export * from "./DisplayActivityTable.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayActivityTable.vue?vue&type=style&index=0&id=a90a01c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90a01c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet})
